import SceneUtils from "../utils/sceneUtils";

export default class EndGamePanel {
    static preload(scene){
    }

    constructor({scene}) {
        this.scene = scene;

        this.panel = this.scene.add.image(
            this.scene.game.config.width / 2,
            this.scene.game.config.height / 2,
            "board"
        );
        this.panel.setScale(0.5);

        this.gameOverText = this.scene.add.text(this.scene.game.config.width / 2,
            this.scene.game.config.height / 2 - 170, 'Game Over',
            {
                fill: "#141",
                fontSize: "40px",
                fontFamily: "Splurge"
            });

        this.gameOverText.setOrigin(0.5);

        this.container = this.scene.rexUI.add.sizer({
            orientation: "x",
            anchor: "center",
            x: this.scene.game.config.width / 2,
            y: this.scene.game.config.height / 2
        });

        this.sSizer = this.scene.rexUI.add.overlapSizer({
            // x: 0,
            // y: 0,
            // anchor: undefined,
            // width: undefined,
            // height: undefined,
            // space: { left: 0, right:0, top:0, bottom:0 },

            // name: '',
            // draggable: false,
            // sizerEvents: false,
            // enableLayer: false,
        });

        this.sTextBehind = this.scene.add.text(0, 0, 'Score: ',
            {
                fill: "#000",
                fontSize: "63px",
                fontFamily: "Splurge"
            });
        this.sText = this.scene.add.text(0, 0, 'Score: ',
            {
                fill: "#D8D741",
                fontSize: "60px",
                fontFamily: "Splurge"
            });

        this.sSizer.add(this.sTextBehind, {align: "center"});
        this.sSizer.add(this.sText, {align: "center"});

        this.sSizer.layout();

        this.scoreSizer = this.scene.rexUI.add.overlapSizer({
            // x: 0,
            // y: 0,
            // anchor: undefined,
            // width: undefined,
            // height: undefined,
            // space: { left: 0, right:0, top:0, bottom:0 },

            // name: '',
            // draggable: false,
            // sizerEvents: false,
            // enableLayer: false,
        });

        this.scoreTextBehind = this.scene.add.text(0, 0, '230',
            {
                fill: "#000",
                fontSize: "65px",
                fontFamily: "Splurge"
            });
        this.scoreText = this.scene.add.text(0, 0, '230',
            {
                fill: "#D8D741",
                fontSize: "60px",
                fontFamily: "Splurge"
            });

        this.scoreSizer.add(this.scoreTextBehind, {align: "center"});
        this.scoreSizer.add(this.scoreText, {align: "center"});

        this.scoreSizer.layout();

        this.container.add(this.sSizer, {padding: {right: 20}});
        this.container.add(this.scoreSizer);
        this.container.layout();

        this.scene.input.on("pointerup", () => {
            if(this.hidden) return;
            SceneUtils.startFullscreen(this);
            if (typeof gdsdk !== 'undefined' && gdsdk.showAd !== 'undefined') {
                gdsdk.showAd();
            }
            this.scene.scene.start('Menu');
        })

        this.hide();
    }


    hide(){
        this.hidden = true;
        this.container.visible = false;
        this.panel.visible = false;
        this.gameOverText.visible = false;
    }

    show(){
        this.container.visible = true;
        this.panel.visible = true;
        this.hidden = false;
        this.gameOverText.visible = true;
    }

    changeScore(score){
        this.scoreText.setText(score);
        this.scoreTextBehind.setText(score);
    }
}